import { render } from "./SkillList.vue?vue&type=template&id=149c2a9c&scoped=true"
import script from "./SkillList.vue?vue&type=script&lang=js"
export * from "./SkillList.vue?vue&type=script&lang=js"

import "./SkillList.vue?vue&type=style&index=0&id=149c2a9c&scoped=true&lang=css"

import exportComponent from "/home/aungkhantkoko/Desktop/PortFolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-149c2a9c"]])

export default __exports__